
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";

const MESSAGES = defineMessages({
  label: {
    id: "TroughBanner.label",
    defaultMessage: "Which troughs are available?",
  },
  text: {
    id: "TroughBanner.text",
    defaultMessage: "Take a look in advance here.",
  }
});

export default MESSAGES;